<template>
  <!-- 评价中心页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="订单跟踪" left-arrow @click-left="$router.back()" />
    </div>
    <div class="center">
      <div class="logisticsTitle">
        <div class="logisticsName">
          <img src="../../assets/img/组 10126@2x.png" alt="" />
          <div>
            <p>{{ this.logName }}</p>
            <p>官方电话：{{ this.logPhone }}</p>
          </div>
        </div>
        <div class="logisticsNumInfo">
          <p class="logisticsNum" :data-clipboard-text="this.logisticsNum">
            <span>物流单号:            {{ this.logisticsNum }}</span>
            <button class="btn" @click="copy">复制</button>
          </p>
        </div>
      </div>
      <div v-if="logisticsListShow" class="logisticsInfo">
        <van-steps direction="vertical" :active="0">
          <van-step v-for="(item, index) in logisticsList" :key="index">
            <span>{{ item.AcceptStation }}</span>
            <p>{{ item.AcceptTime }}</p>
          </van-step>
        </van-steps>
      </div>
      <div v-else class="logisticsInfo">
        <van-steps direction="vertical" :active="0">
          <van-step>
            <span>{{ context }}</span>
          </van-step>
        </van-steps>
      </div>
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
// 点击复制的插件
import Clipboard from "clipboard";
export default {
  data() {
    return {
      logisticsList: {},
      LoadingShow: true,
      logisticsListShow: true,
      logName: "",
      logPhone: "",
      logisticsNum: "",
      context: "",
      // orderCode: sessionStorage.getItem("orderCode")
    };
  },
  created() {
    this.getLogistics();
  },
  methods: {
    // 获取物流信息
    async getLogistics() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "/oor/findLOGByCode",
        method: "get",
        params: {
          recordCode: orderCode,
        },
      })
        .then((res) => {
          if (
            res.retCode == 200 &&
            (res.data.state !== undefined || res.data.state !== null)
          ) {
            this.LoadingShow = false;
            this.logisticsListShow = true;
            this.logisticsList = res.data.data2.reverse();
            (this.logName = res.data.lOGName),
              (this.logPhone = res.data.lOGPhone);
            this.logisticsNum = res.data.nu;
          } else {
            this.logisticsListShow = false;
            this.LoadingShow = false;
            this.context = res.data.message;
            (this.logName = res.data.lOGName),
              (this.logPhone = res.data.lOGPhone);
            this.logisticsNum = res.data.nu;
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 复制功能
    copy() {
      var clipboard = new Clipboard(".logisticsNum");
      clipboard.on("success", (e) => {
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  background-color: #eeeeee;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    background-color: #1f000000;
    padding-top: 1.2rem;
    .logisticsTitle {
      margin: 0.4rem;
      padding: 0.3rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      box-shadow: 0px 0px 5px 1px #bfbfbf;
      .logisticsName {
        display: flex;
        align-items: center;
        padding: 0.2rem 0;
        border-bottom: 0.026667rem solid #eeeeee;
        img {
          width: 1.333333rem;
          height: auto;
        }
        div {
          margin-left: 0.3rem;
          font-size: 0.373333rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #000000;
        }
      }
      .logisticsNumInfo {
        padding: 0.3rem 0 0 0;
        font-size: 0.373333rem;
        font-family: PingFang SC;
        font-weight: 400;
        
        p {
          display: flex;
          justify-content: space-between;
        }
        .btn {
          border: 0px;
          // display: block;
          background-color: #fff;
          color: #3fbaa4;
          font-size: 0.373333rem;
        }
      }
    }
    .dividingLine {
      margin-top: 0.5rem;
      width: 100%;
      height: 0.1rem;
      background: -webkit-linear-gradient(
          bottom,
          hsla(59%, 0%, 59%, 0.15),
          hsla(0, 0%, 59%, 0),
          rgba(245, 245, 245, 1)
        )
        no-repeat;
    }
    .logisticsInfo {
      box-shadow: 0px 0px 5px 1px #bfbfbf;
      margin: 0 0.27rem;
      height: 100%;
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
